const timelineElements = [
    {
      id: 2,
      title: "Glo.",
      location: "Co-founder & CEO | Chapel Hill, NC | June 2025 - Present",
      description: 
      [
        "Building an AI and AR-powered beauty app with React Native, Node.js, Postgres SQL, and Google Cloud for personalized tutorials and real-time virtual try-ons",
        "Integrating GPT-4 Vision for AI-driven makeup analysis and leveraging AR to adapt looks to each user’s facial features and skin tone"
      ],
      date: "Jun 25 - Present",
      icon: "work",
      tech: ["React Native", "Javascript", "Node.js", "Express", "PostgresSQL", "Google Could", "GPT4 Vision", "AR"],
    },
    {
      id: 2,
      title: "Amazon",
      location: "Software Developer Intern | Seattle, WA | May 2025 - Present",
      description: 
      ["Built a fully automated, end-to-end EC2 data validation pipeline using a custom Python framework, AWS Glue, Spark, S3, Athena, and CloudWatch to run custom validations and surface key metrics—discovered over 1.5 million unsellable instance errors, reducing capital expenditures by ~$10K per instance"],
      date: "May 25 - Present",
      icon: "work",
      tech: ["Python", "Spark", "AWS Glue", "AWS Cloudwatch", "AWS Athena", "S3"],
    },
    {
      id: 3,
      title: "Voicera",
      location: "Software Engineer Intern | Remote | August 2024 - December 2024",
      description: 
      [
        "Optimized core components using TypeScript and React in Voicera’s multimodal AI app—reduced UI latency by ~25% and cut component load times by ~30% through targeted refactoring and performance tuning",
        "Conducted 40+ code reviews and resolved 100+ bugs, boosting overall application responsiveness and raising front-end test coverage by 15%"
      ],
      date: "August 24 - December 24",
      icon: "work",
      tech: ["React", "TypeScript", "AWS"],
    },
    {
      id: 4,
      title: "Arrow Logistics",
      location: "Software Engineer Intern | Remote | June 2024 - August 2024",
      description: 
      [
        "Implemented a dynamic real-time shipment tracking system using Node.js, Express, and PostgreSQL, improving tracking for 1,000+ daily shipments and boosting data processing efficiency by over 20%.",
        "Developed and integrated API solutions for real-time shipping updates, utilizing Kafka for event-driven architecture to ensure reliable and scalable message processing, increasing customer engagement by 15%"
      ],
      date: "June 24 - August 24",
      icon: "work",
      tech: ["Node.js", "Express", "PostgresSQL", "Kafka"],
    },
    {
      id: 5,
      title: "Depository Trust & Clearing Corporation (DTCC)",
      location: "Software Engineer Intern | Tampa, Florida | June 2023 - August 2023",
      description: 
        [
        "Collaborated with a cross-functional team of 10+ people globally to develop and implement two innovative technological solutions in a company-wide effort to decrease the US settlement cycle to T+1",
        "Learned and applied SQL database schemas and queries to efficiently support data storage and retrieval for a database containing over 300,000 entries",
        "Contributed to the development of user-friendly data visualizations and dashboards representing 200k+ data entries using business intelligence tools leading to the facilitation of data-driven decision-making for management and stakeholders",
        "Assisted in the planning and execution of data migration projects, ensuring seamless transitions and minimal disruption to business operations for 3+ departments",
        "Designed and implemented RESTful APIs using Spring Boot and Java to enhance communication between front-end and back-end legacy financial systems on a web application utilized by over 3,000 employees.", 
      ],
      date: "June 23 - August 23",
      icon: "work",
      tech: ["Java", "SpringBoot", "SQL", "Power BI"],
    },

    {
      id: 6,
      title: "CISCO",
      location: "Cisco High Insight Extern | NYC, New York | June 2021 - July 2021 ",
      description: 
      [
        "Formulated a comprehensive business plan utilizing innovative Cisco technology, aimed at optimizing healthcare services for increased efficiency; focused on the integration of cutting-edge solutions to streamline healthcare delivery and enhance patient care",
        "Pitched strategic recommendations to a panel of 5+ Cisco executives",
        "Earned 3rd best rating out of 35 other candidates in the program ",
        "Diversified technical expertise in the fields of cybersecurity, Devnet, AppD, and IoT - Cisco Cybersecurity Certified",
      ],
      date: "June 21 - July 21",
      icon: "work",
      tech: ["Devnet", "IoT", "AppD", "Cybersecurity"],
    },
    {
      id: 7,
      title: "Ria International",
      location: "Business Development Intern | Raliegh, NC | January 2019 - May 2022",
      description: [
        "Researched 25+ scrap metal companies to develop a sustainable scrap metal import/export business plan",
        "Scheduled weekly material transportation for 40+ trucks leading to a 95% order completion rate on time",
        "Successfully nurtured and forged strong client relationships on an international scale with more than 14 partners by utilizing a combination of strategic networking, attentive communication, and a keen understanding of each partner’s unique needs and preferences"
      ],
      date: "January 19 - May 22",
      icon: "work",
      tech: ["Excel", "Tableu"],
    },
  ];
  
  export default timelineElements;